import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Tooltip from "react-tooltip-lite";
import { SelectedAccountContext } from "../../../Context/SelectedAccountContext/SelectedAccountContext";
import { useOutsideClick } from "../../../utils/useOutsideClick";
import "./UserChangeAccountButton.css";

export const UserChangeAccountButton = ({ accounts }) => {
  const { t } = useTranslation();
  const [tooltipOpen, setTooltip] = useState(false);
  const { selectedAccount, setSelectedAccount } = useContext(
    SelectedAccountContext
  );

  const ref = useRef();

  useOutsideClick(ref, () => setTooltip(false));

  return (
    <div
      className="UserChangeAccountButton"
      onClick={() => setTooltip(!tooltipOpen)}
      ref={ref}
    >
      <Tooltip
        isOpen={tooltipOpen}
        direction="right-start"
        distance={0}
        padding={0}
        arrow={false}
        content={
          <div className="UserChangeAccountButton__tooltip">
            {accounts.map((a) => (
              <div
                className={
                  selectedAccount.id === a.id
                    ? "UserChangeAccountButton__tooltip-item UserChangeAccountButton__tooltip-item--active"
                    : "UserChangeAccountButton__tooltip-item"
                }
                key={a.id}
                onClick={() => {
                  setSelectedAccount(a);
                  setTooltip(false);
                }}
              >
                {a.name}
              </div>
            ))}
          </div>
        }
      >
        <div className="UserChangeAccountButton__text">
          {t("profile.changeAccount")}
        </div>
      </Tooltip>
    </div>
  );
};
